import React, { useEffect, useState } from 'react';
import { STATUS } from '../../../../redux/constants';
import { Form, Spin, Modal, Select } from 'antd';

export default function SearchUsersComponent(props) {
  const renderUsersSelectOptions = () => {
    const usersInfoList = props?.usersInfoForStaffMember.filter(
      (item) => item.organisation_uuid !== props.customerOrganizationData.uuid,
    );
    return usersInfoList?.map((option) => (
      <Select.Option key={option.email} value={option.username}>
        {option.email}
      </Select.Option>
    ));
  };

  return (
    <Modal
      centered
      bodyStyle={{ padding: 24 }}
      title={'Invite User'}
      open={props?.isModalOpen}
      onOk={() => {
        props.handleTranser();
      }}
      onCancel={() => {
        props.setIsTransferUSerModalOpen(false);
      }}
      okText="Invite"
    >
      <Form>
        <Form.Item
          name="user"
          rules={[
            {
              required: true,
              message: 'You have to select a user.',
            },
          ]}
        >
          <Select
            showSearch
            placeholder={`Select User`}
            style={{ minWidth: '100%' }}
            loading={props?.usersInfoForStaffMemberStatus != STATUS.LOADED}
            onChange={(selectedUserUsername) => {
              props.setSelectedUserToTranser(selectedUserUsername);
            }}
            allowClear
            onSearch={props?.handleFilter}
            filterOption={false}
          >
            {props?.usersInfoForStaffMemberStatus == STATUS.LOADED ? (
              renderUsersSelectOptions()
            ) : (
              <Select.Option value="loading" disabled>
                <Spin size="small" /> Loading...
              </Select.Option>
            )}
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  );
}
